import { router } from "@inertiajs/vue3"
import { onMounted, onUnmounted } from "vue"
import { toast } from "vue-sonner"

export const useFlash = () => {
  let removeListener: (() => void) | undefined

  onMounted(() => {
    removeListener = router.on("flash", (event) => {
      const flash = event.detail.flash
      if (flash.notice) toast(flash.notice)
      if (flash.success) toast.success(flash.success)
      if (flash.alert) toast.error(flash.alert)
      if (flash.error) toast.error(flash.error)
    })
  })

  onUnmounted(() => {
    removeListener?.()
  })
}
